import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { Avatar, Box, Button, Rating, Stack, Typography } from "@mui/material";
import Cookies from "js-cookie";
import React from "react";
import { NavLink } from "react-router-dom";
import ReviewsOfUser from "./ReviewsOfUser";

function AboutMe({ user }) {
  const hasBio = user.bio !== null && user.bio !== "";

  return (
    <Box
      flex={3}
      sx={{
        width: "100%",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E3EDF6",
        borderRadius: "22px",
        boxShadow: "0 16px 42px rgba(15,45,75,.08)",
        fontFamily: "Assistant",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: { xs: 2.25, sm: 3, md: 3.5 },
          background: "linear-gradient(135deg, #F7FBFF 0%, #FFFFFF 65%)",
          borderBottom: "1px solid #E8EFF6",
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          spacing={2.2}
        >
          <Stack direction="row" alignItems="center" spacing={1.7} sx={{ direction: "ltr" }}>
            <Avatar
              sx={{
                width: { xs: 68, md: 78 },
                height: { xs: 68, md: 78 },
                bgcolor: "#1677C8",
                color: "#FFFFFF",
                fontSize: { xs: 22, md: 25 },
                fontWeight: 900,
                border: "5px solid #EAF4FF",
                boxShadow: "0 10px 25px rgba(22,119,200,.18)",
              }}
            >
              {user.name.charAt(0) + " " + user.last_name.charAt(0)}
            </Avatar>
            <Box sx={{ direction: "rtl", textAlign: "right" }}>
              <Typography sx={{ fontFamily: "Assistant", fontWeight: 900, color: "#17324D", fontSize: { xs: "21px", md: "25px" } }}>
                {user.username}
              </Typography>
              <Typography sx={{ fontFamily: "Assistant", color: "#73879A", fontSize: "14px", mt: 0.2 }}>
                הפרופיל שלי בבידאיט
              </Typography>
              {hasBio && (
                <Stack direction="row" alignItems="center" spacing={0.7} sx={{ mt: 0.8 }}>
                  <Rating dir="ltr" name="simple-controlled" value={user.rating} precision={0.5} readOnly size="small" />
                  <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, color: "#4C6479", fontSize: "13px" }}>
                    דירוג {user.rating || 0}
                  </Typography>
                </Stack>
              )}
            </Box>
          </Stack>

          {Cookies.get("id").toString() === user.id.toString() && (
            <NavLink to="/editprofile" style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                startIcon={<EditRoundedIcon />}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  minHeight: 44,
                  fontFamily: "Assistant",
                  borderRadius: "12px",
                  borderColor: "#B8D8F2",
                  color: "#1677C8",
                  fontWeight: 800,
                  px: 2.1,
                  textTransform: "none",
                  backgroundColor: "#FFFFFF",
                  "&:hover": { backgroundColor: "#EAF4FF", borderColor: "#8CC1EC" },
                }}
              >
                עריכת פרופיל
              </Button>
            </NavLink>
          )}
        </Stack>
      </Box>

      <Box sx={{ p: { xs: 2.25, sm: 3, md: 3.5 } }}>
        <Box
          sx={{
            p: { xs: 2, md: 2.5 },
            border: "1px solid #E6EEF5",
            borderRadius: "18px",
            backgroundColor: "#FBFDFF",
            mb: 2.5,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.25 }}>
            <Box sx={{ width: 38, height: 38, display: "grid", placeItems: "center", borderRadius: "12px", bgcolor: "#EAF5FF", color: "#1677C8" }}>
              <PersonRoundedIcon fontSize="small" />
            </Box>
            <Typography sx={{ fontFamily: "Assistant", fontWeight: 900, color: "#17324D", fontSize: "17px" }}>
              קצת על עצמי
            </Typography>
          </Stack>
          <Typography sx={{ fontFamily: "Assistant", color: hasBio ? "#40566D" : "#8797A6", lineHeight: 1.8, fontSize: "15.5px", whiteSpace: "pre-line" }}>
            {hasBio ? user.bio : "עדיין לא הוספת מידע אישי לפרופיל. אפשר להוסיף כמה מילים דרך עריכת הפרופיל."}
          </Typography>
        </Box>

        <Box
          sx={{
            p: { xs: 2, md: 2.5 },
            border: "1px solid #E6EEF5",
            borderRadius: "18px",
            backgroundColor: "#FFFFFF",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
            <Box sx={{ width: 38, height: 38, display: "grid", placeItems: "center", borderRadius: "12px", bgcolor: "#FFF8E8", color: "#D99700" }}>
              <StarRoundedIcon fontSize="small" />
            </Box>
            <Box>
              <Typography sx={{ fontFamily: "Assistant", fontWeight: 900, color: "#17324D", fontSize: "17px" }}>
                דירוג וחוות דעת
              </Typography>
              <Typography sx={{ fontFamily: "Assistant", color: "#8191A1", fontSize: "12.5px" }}>
                לעדכון ניתן לפנות אלינו
              </Typography>
            </Box>
          </Stack>
          <ReviewsOfUser id={user.id} />
        </Box>
      </Box>
    </Box>
  );
}

export default AboutMe;
